import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'
import { Image } from 'react-native'

import { Page } from 'partials/Page'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useAuth } from 'hooks/useAuth'
import { useCoachReferral } from 'hooks/useCoachReferral'
import { useMaxWidth } from 'hooks/useMaxWidth'

import { links } from 'utils/constants'
import commonStyles from 'utils/styles/commonStyles'

import ShowUpTextImage from 'assets/images/ShowUpText.png'

export const AuthWelcomePage = ({ navigation }: CompositeScreenProps<any, any>) => {
  const { width: maxWidth } = useMaxWidth()

  const { login } = useAuth()
  const { isReferral } = useCoachReferral()

  const facebookError = login.facebook.error
  const googleError = login.google.error
  const appleError = login.apple.error

  const error = googleError || facebookError || appleError

  const navigateToSignUpPage = () => {
    navigation.navigate(links.SIGNUP_PAGE, {})
  }

  isReferral && navigateToSignUpPage()

  return (
    <Page center navigation={navigation}>
      <Box flex={1} display='flex' flexDirection='column'>
        <Box
          flex={0.5}
          testID='WelcomePageInnerContainer'
          flexDirection='column'
          align='center'
          justifyContent='center'
        >
          <Box>
            <Box height={48} />
            <Icon color='v2primary' name='upspace-logo-mark' size={70} />
          </Box>
          <Box margin='sm'>
            <Icon color='black' name='upspace-word-mark' size={42} />
          </Box>
          {error ? (
            <Box align='center'>
              <Text color='error'>{error}</Text>
            </Box>
          ) : null}
        </Box>

        <Box flex={1} zIndex={9} align='center' justifyContent='center' padding='sm'>
          <Box
            width={maxWidth}
            height={maxWidth === 600 ? maxWidth * 0.8 : maxWidth * 0.93}
            margin={{ right: 'xs' }}
          >
            <Image resizeMode='cover' style={commonStyles.fullSize} source={ShowUpTextImage} />
          </Box>
        </Box>

        <Box flex={0.5} flexDirection='column' justifyContent='center'>
          <Box margin={{ horizontal: 'md', bottom: 'xl' }}>
            <Pressable link={links.LOGIN_PAGE}>
              <Box
                height={50}
                borderRadius='xs'
                border={{ color: 'v2primary', width: 2 }}
                backgroundColor='white'
                justifyContent='center'
                align='center'
              >
                <Text bold color='black'>
                  LOG IN
                </Text>
              </Box>
            </Pressable>
            <Box height={12} />
            <Pressable link={links.SIGNUP_PAGE}>
              <Box
                height={50}
                borderRadius='xs'
                border={{ color: 'white', width: 2 }}
                backgroundColor='v2primary'
                justifyContent='center'
                align='center'
              >
                <Text color='white' bold>
                  SIGN UP
                </Text>
              </Box>
            </Pressable>
          </Box>
        </Box>
      </Box>
    </Page>
  )
}
